import { SchedulerItemOnMachine } from './item-on-machine';
import { SchedulerMachineWorkOrder } from './wo-machine';
import { SchedulerWorkOrder } from './work-order';

export class SchedulerWorkOrderOnMachine extends SchedulerItemOnMachine {
  machine: SchedulerMachineWorkOrder;

  workOrderId: number;
  /**
   * @deprecated
   */
  transactionId: number;
  get itemId(): number {
    return this.workOrderId ?? this.transactionId;
  }
  get item(): SchedulerWorkOrder {
    return this.workOrder;
  }

  get startedRunningAt(): string {
    return this.lastOperationDate;
  }
  set startedRunningAt(val: string) {
    this.lastOperationDate = val;
  }
  workOrder: SchedulerWorkOrder = undefined;
}
